module.exports = __webpack_public_path__ + "static/media/links.8a2ec5f4.svg";